import React from "react";
import { TrashIcon } from "../../SVG/trash-icon";
import { useCriteriaTreeBuilderContext } from "./criteria-tree-builder-context";
import { CriteriaStatement } from "./criteria-tree-builder-types";

export interface CriteriaStatementRowProps {
  statement: CriteriaStatement;
  onStatementChange: (statementId: string, statementValue: string) => void;
  onRemove: (nodeId: string) => void;
  /** 0-based depth from the root group (a statement directly in the root group is 0). */
  depth?: number;
}

/**
 * A single statement row: a custom statement field (via renderStatementInput)
 * plus a delete action.
 *
 * Root-level statements (depth 0) render inside a bordered "condition" card —
 * a double box (card + input). Statements nested inside a group render bare
 * (just the input), so nested groups don't stack extra boxes around each row.
 */
const CriteriaStatementRow = ({
  statement,
  onStatementChange,
  onRemove,
  depth = 0,
}: CriteriaStatementRowProps) => {
  const { disabled, labels, renderStatementInput } =
    useCriteriaTreeBuilderContext();

  const customInput = renderStatementInput({
    statement,
    onStatementChange: (v) => onStatementChange(statement.id, v),
  });

  const isBare = depth > 0;

  return (
    <div
      className={`criteria-tree-builder__condition${isBare ? " criteria-tree-builder__condition--bare" : ""}${disabled ? " criteria-tree-builder__condition--disabled" : ""}`}
    >
      <div className="criteria-tree-builder__condition-field">{customInput}</div>
      <button
        type="button"
        onClick={() => onRemove(statement.id)}
        className="criteria-tree-builder__delete"
        aria-label={labels.removeCondition}
        disabled={disabled}
        tabIndex={disabled ? -1 : 0}
      >
        <TrashIcon size={18} />
      </button>
    </div>
  );
};

export default CriteriaStatementRow;